import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../../auth/store/auth.selectors';
import { Box, CircularProgress, Alert, Button, AppBar, Toolbar, Typography } from '@mui/material';
import LaneMarkingRecorder from './LaneMarkingRecorder';
import { selectedDriveVideoURL, driveVideoUrlLoading } from '../../drive/store/drive.selectors';
import { setDriveVideoURL } from '../../drive/store/drive.actions';
import Breadcrumbs from '../../layout/Breadcrumbs';
function LaneMarkingPage() {
  const { driveId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const videoUrl = useSelector(selectedDriveVideoURL);
  const isLoading = useSelector(driveVideoUrlLoading);
  const user = useSelector(selectAuthUser);

  const [currentTime, setCurrentTime] = useState(0);
  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Collections', path: '/collections' },
    { label: 'Drives', path: '/drives' },
    { label: 'Lane Management', path: `/lane-marking/${driveId}` },
  ];
  const currentRoleId = Number(
    user?.roleID ||
      user?.roleId ||
      user?.roleid ||
      JSON.parse(localStorage.getItem('user') || '{}')?.roleid
  );
  const shouldShowBreadcrumbs = [1, 2, 3].includes(currentRoleId);
  const storedRow = localStorage.getItem('selectedDriveRow');
  let row = null;
  try {
    row = storedRow ? JSON.parse(storedRow) : null;
  } catch (e) {
    row = null;
  }
  dispatch(setDriveVideoURL(row?.video_url)); // Ensure video URL is set in Redux state
  if (!driveId) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          No drive ID provided. Cannot load lane marking recorder.
        </Alert>
        <Button onClick={() => navigate('/drives')} variant="contained">
          Back to Drives
        </Button>
      </Box>
    );
  }

  if (isLoading && !videoUrl) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography>Loading video for Drive: {row?.name || 'Unknown Drive'}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <AppBar position="static">
        <Toolbar
          sx={{ gap: 1, background: '#fff', padding: '0.5rem 1rem', borderRadius: '0 0 10px 10px' }}
        >
          {shouldShowBreadcrumbs && <Breadcrumbs items={breadcrumbItems} />}
          <Typography
            variant="h6"
            sx={{
              flex: 1,
              paddingRight: 4,
              fontWeight: 'bold',
              fontSize: '1.25rem',
            }}
          >
            Lane Management Suite - {row?.name || 'Drive ' + driveId}
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <LaneMarkingRecorder
          driveId={driveId}
          videoUrl={videoUrl}
          currentTime={currentTime}
          setCurrentTime={setCurrentTime}
          userId={user?.id || user?.userId}
        />
      </Box>
    </Box>
  );
}

export default LaneMarkingPage;
